export default __webpack_public_path__ + "static/media/330_business03-es-mobile.a71d56cd.png";